import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

/*
  Up and down arrows for any list that can be dragged into order.

  Put it beside a row's drag handle, give it the same list the table shows and the row's index,
  and an arrow moves the row one place - exactly as a drag does: the list is reordered in place,
  the way PrimeNG's table reorders it on a drop, and then (moved) fires with the same
  { dragIndex, dropIndex } the table's onRowReorder sends. So a page that does something when a
  row is dropped - saves the new order, renumbers - can hand (moved) to the same handler and an
  arrow click and a drag end up the same.

  The arrows also work on a phone, where rows cannot be dragged by touch.
*/
@Component({
  selector: 'app-row-move',
  template: `
    <span class="row-move">
      <button pButton type="button" class="p-button-sm p-button-text row-move-btn"
        [disabled]="list == null || index <= 0" (click)="move(-1, $event)" pTooltip="Move up" tooltipPosition="top" [iconOnly]="true"><span class="p-button-icon pi pi-arrow-up" aria-hidden="true"></span></button>
      <button pButton type="button" class="p-button-sm p-button-text row-move-btn"
        [disabled]="list == null || index >= list.length - 1" (click)="move(1, $event)" pTooltip="Move down" tooltipPosition="top" [iconOnly]="true"><span class="p-button-icon pi pi-arrow-down" aria-hidden="true"></span></button>
    </span>
  `,
  styleUrls: ['./row-move.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class RowMoveComponent {
  @Input() list: any[];
  @Input() index: number;

  @Output() moved = new EventEmitter<{ dragIndex: number, dropIndex: number }>();

  move(by: number, event: Event) {
    //Rows on some pages open something when clicked; an arrow is not a click on the row.
    event.stopPropagation();

    const from = Number(this.index);
    const to = from + by;

    if (this.list == null || to < 0 || to >= this.list.length) {
      return;
    }

    this.list.splice(to, 0, this.list.splice(from, 1)[0]);

    this.moved.emit({ dragIndex: from, dropIndex: to });
  }
}
